import { Call } from '@twilio/voice-sdk';
import { DialerControlsState } from '../../../components/dialer/dialer-slice';
import {
  CallLog,
  DialerCallSourceEnum,
} from '../../../components/dialer/types/call-logs';
import {
  EndInitiatedCallPayload,
  InitiateCallPayload,
} from '../../../components/dialer/types/manual-call-dialing';
import { RequestStatus } from '../../enums/request-status';

export interface CountryOption {
  countryCode: string;
  countryName: string;
}

export interface CallViaOption {
  id: number;
  label: string;
  value: string;
  isPrimary?: boolean;
}

export interface DialerPhoneNumberOption {
  phoneType?: string | null;
  isPrimary?: boolean | null;
  callingCode?: string | null;
  number?: string | null;
  phoneNumber?: string | null;
  countryISOCode?: string | null;
}

export interface IncomingCallProspect {
  firstName?: string | null;
  lastName?: string | null;
  incomingPhoneNumber?: string | null;
}

export interface ProspectOption extends IncomingCallProspect {
  id?: string;
  phoneNumbers?: DialerPhoneNumberOption[];
  jobTitle?: string;
  companyName?: string;
  callSource?: DialerCallSourceEnum;
}

export interface DialerPopupProps {
  dialerPhoneNumberList?: Array<{
    id: number;
    phoneNumber: string;
    friendlyName: string;
    isPrimaryNumber: boolean;
  }>;
  onCallClick: (payload: InitiateCallPayload) => void;
  onCallDisconnect: (payload: EndInitiatedCallPayload) => void;
  onClose?: () => void;
  initiateCall?: boolean;
  initiateRinging?: boolean;
  initiatedCallId?: string | null;
  callManagementState?: CallManagementState;
  setCallManagementState?: React.Dispatch<
    React.SetStateAction<CallManagementState>
  >;
  holdCallHandlers?: any;
  onPreCallTestClick?: () => void;
  selectedCallbackProspect?: CallLog[];
  isCallConnected?: boolean;
  setIsCallConnected?: (status: boolean) => void;
  incomingCallProspect?: IncomingCallProspect | null;
  isInPip?: boolean;
  pipContainer?: HTMLElement | null;
  callConnectedAt?: number | null;
  onVoicemailDropped?: (callId: number) => void;
}

export interface ControlsState {
  microphone: boolean;
  hold: boolean;
  record: boolean;
  voicemail: boolean;
}

/** Shared props for dialer control icons (microphone, hold, record) */
export interface CallControlIconProps {
  isActive: boolean;
  className?: string;
}

export interface DialerRingingProps {
  isCallConnected: boolean;
  onCallDisconnect: () => void;
  initiatedCallId?: string | null;
  selectedProspect?: any;
  selectedCountryCode?: string;
  ongoingPhoneNumber?: string;
  callManagementState?: CallManagementState;
  controlsState?: DialerControlsState;
  endInitiatedCall?: boolean;
  holdCallHandlers?: any;
  dropVoicemailTemplateRequestStatus?: RequestStatus;
  inboundCallPhoneNumber?: string | null;
}
export interface PhoneNumberEntry {
  label?: string;
  number: string;
  isPrimary?: boolean;
  phoneNumber?: string;
}

export interface PhoneNumbersPickerSheetProps {
  isOpen: boolean;
  onClose: () => void;
  contactName: string;
  phoneNumbers: (PhoneNumberEntry | string)[];
  onSelectNumber: (number: string) => void;
  /** When true, positions inside parent container instead of viewport */
  inline?: boolean;
  prospectName?: string | null;
}

export enum DialerPhoneNumberCallStatusEnum {
  // Same as backend enum
  INITIATED = 1,
  RINGING = 2,
  ANSWERED = 3,
  COMPLETED = 4,
  FAILED = 5,
}

export type CallStatus =
  | 'initiated'
  | 'ringing'
  | 'answered'
  | 'completed'
  | 'failed'
  | null;
export interface CallManagementState {
  call?: Call | null;
  isTwilioServiceRegistered: boolean;
  errorInTwilioService: Error | null;
  callStatus: CallStatus;
  callTwilioStatus:
    | 'ideal'
    | 'registered'
    | 'connected'
    | 'disconnected'
    | 'reconnecting'
    | 'error'
    | null;
  callIsInprogress: boolean;
  callDirection: 'outbound' | 'inbound' | null;
  acceptedCallId: number | null;
}
